import classNames from 'classnames'
import styles from './styles.module.scss'

const Popover = ({ renderTitle, renderContent, direction = 'top', className }) => (
    <div className={classNames('popover', `popover-${direction}`, styles.popover, className)}>
        <div className={classNames('popover-title', styles.popoverTitle)}>{renderTitle ? renderTitle() : null}</div>
        <div className={styles.popoverContent}>{renderContent ? renderContent() : null}</div>
    </div>
)

export default Popover
